export const result = [
  {
    utc: 1717381364,
    lon: 121397253,
    lat: 38821207,
    sog: 0,
    cog: 0,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717382654,
    lon: 121398083,
    lat: 38821963,
    sog: 309,
    cog: 2690,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717401976,
    lon: 121398030,
    lat: 38822065,
    sog: 0,
    cog: 0,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717447969,
    lon: 121397987,
    lat: 38821950,
    sog: 0,
    cog: 0,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717449237,
    lon: 121400705,
    lat: 38802543,
    sog: 4527,
    cog: 17860,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717449261,
    lon: 121400737,
    lat: 38801318,
    sog: 4527,
    cog: 17860,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717449386,
    lon: 121401187,
    lat: 38796337,
    sog: 4630,
    cog: 17840,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717449476,
    lon: 121401337,
    lat: 38792533,
    sog: 4733,
    cog: 17800,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717449567,
    lon: 121401402,
    lat: 38788673,
    sog: 4630,
    cog: 17970,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717450177,
    lon: 121398013,
    lat: 38774550,
    sog: 206,
    cog: 24520,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717451243,
    lon: 121395383,
    lat: 38772887,
    sog: 4527,
    cog: 22910,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717451580,
    lon: 121379073,
    lat: 38766812,
    sog: 4681,
    cog: 23890,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717453048,
    lon: 121306002,
    lat: 38742795,
    sog: 4784,
    cog: 24780,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717453115,
    lon: 121302843,
    lat: 38741867,
    sog: 4784,
    cog: 25100,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717453289,
    lon: 121293462,
    lat: 38739067,
    sog: 4887,
    cog: 24910,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717453385,
    lon: 121288695,
    lat: 38737662,
    sog: 4836,
    cog: 24910,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717453950,
    lon: 121258448,
    lat: 38728647,
    sog: 5042,
    cog: 24400,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717454228,
    lon: 121243808,
    lat: 38723847,
    sog: 5144,
    cog: 24620,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717454527,
    lon: 121226937,
    lat: 38719078,
    sog: 5350,
    cog: 25210,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717454858,
    lon: 121206753,
    lat: 38714687,
    sog: 5607,
    cog: 25950,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717454883,
    lon: 121204765,
    lat: 38714402,
    sog: 5659,
    cog: 25840,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455009,
    lon: 121196905,
    lat: 38713887,
    sog: 5813,
    cog: 26450,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455069,
    lon: 121192860,
    lat: 38713663,
    sog: 5916,
    cog: 26370,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455130,
    lon: 121188740,
    lat: 38713523,
    sog: 6070,
    cog: 26520,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455154,
    lon: 121186648,
    lat: 38713462,
    sog: 6070,
    cog: 27020,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455219,
    lon: 121182333,
    lat: 38713340,
    sog: 6122,
    cog: 27070,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455309,
    lon: 121175868,
    lat: 38713272,
    sog: 6225,
    cog: 27040,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455430,
    lon: 121167208,
    lat: 38713265,
    sog: 6328,
    cog: 26940,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455581,
    lon: 121155880,
    lat: 38713745,
    sog: 6585,
    cog: 27060,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455731,
    lon: 121144478,
    lat: 38714332,
    sog: 6482,
    cog: 27630,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455822,
    lon: 121138397,
    lat: 38715898,
    sog: 5968,
    cog: 29280,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455883,
    lon: 121134593,
    lat: 38717313,
    sog: 6173,
    cog: 29980,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717455942,
    lon: 121131007,
    lat: 38719202,
    sog: 6173,
    cog: 31040,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456002,
    lon: 121128013,
    lat: 38721602,
    sog: 6173,
    cog: 32130,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456063,
    lon: 121125635,
    lat: 38724470,
    sog: 6328,
    cog: 33080,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456124,
    lon: 121123482,
    lat: 38727513,
    sog: 6379,
    cog: 33190,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456183,
    lon: 121122160,
    lat: 38730578,
    sog: 5607,
    cog: 34930,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456244,
    lon: 121121563,
    lat: 38733393,
    sog: 4990,
    cog: 35310,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456304,
    lon: 121121138,
    lat: 38736003,
    sog: 4784,
    cog: 35580,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456364,
    lon: 121120663,
    lat: 38738603,
    sog: 4733,
    cog: 34800,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456424,
    lon: 121120148,
    lat: 38741130,
    sog: 4681,
    cog: 35200,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456515,
    lon: 121119447,
    lat: 38744820,
    sog: 4476,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456604,
    lon: 121119052,
    lat: 38748458,
    sog: 4527,
    cog: 35870,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456689,
    lon: 121119198,
    lat: 38752092,
    sog: 4527,
    cog: 60,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456797,
    lon: 121119035,
    lat: 38755612,
    sog: 4630,
    cog: 35740,
    hdg: 35700,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456845,
    lon: 121118818,
    lat: 38758333,
    sog: 4681,
    cog: 35020,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717456935,
    lon: 121119390,
    lat: 38761425,
    sog: 3498,
    cog: 3480,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717457086,
    lon: 121121747,
    lat: 38764357,
    sog: 1389,
    cog: 1210,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717459306,
    lon: 121121685,
    lat: 38765218,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717461108,
    lon: 121121695,
    lat: 38765258,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717463014,
    lon: 121121685,
    lat: 38765250,
    sog: 51,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717464815,
    lon: 121121682,
    lat: 38765267,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717466616,
    lon: 121121687,
    lat: 38765275,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717468416,
    lon: 121121580,
    lat: 38765332,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717470396,
    lon: 121121583,
    lat: 38765317,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
  {
    utc: 1717472556,
    lon: 121121570,
    lat: 38765322,
    sog: 0,
    cog: 35000,
    hdg: 51100,
    rot: 32767,
    navistatus: 255,
    from: 0,
  },
]
